import React, { useEffect, useMemo, useState, useRef, useLayoutEffect, lazy } from 'react';
import { motion } from 'framer-motion';
import { useClientLogos } from '../hooks/useClientLogos';
// ============================================
// CONTROLES GENERALES
// ============================================
// Velocidad del scroll
const SCROLL_DURATION_SECONDS = 50;
// Espaciado
const GAP = 'gap-8 sm:gap-10 md:gap-12';
const ITEM_W = 'w-32 sm:w-36 md:w-40';
const ITEM_H = 'h-20 sm:h-22 md:h-24';
const LOGO_H = 'max-h-14 sm:max-h-16 md:max-h-18';
export function ClientLogos() {
  const {
    logos
  } = useClientLogos();
  const trackRef = useRef<HTMLDivElement | null>(null);
  const [distance, setDistance] = useState(0);
  const [imgTick, setImgTick] = useState(0);
  // Duplicamos para loop infinito
  const duplicatedLogos = useMemo(() => [...logos, ...logos], [logos]);
  // Medición real en px
  const recalc = () => {
    const el = trackRef.current;
    if (!el) return;
    setDistance(Math.floor(el.scrollWidth / 2));
  };
  useLayoutEffect(() => {
    recalc();
  }, []);
  useEffect(() => {
    recalc();
  }, [imgTick, logos]);
  useEffect(() => {
    window.addEventListener('resize', recalc);
    return () => window.removeEventListener('resize', recalc);
  }, []);
  const shouldAnimate = distance > 0 && logos.length > 0;
  if (logos.length === 0) {
    return null;
  }
  return <section className="py-12 sm:py-16 md:py-20 bg-white overflow-hidden border-y border-gray-100" data-id="element-320">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mb-8 sm:mb-12" data-id="element-321">
        <div className="text-center" data-id="element-322">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-wider text-gray-500 mb-1 sm:mb-2" data-id="element-323">
            Confían en nosotros
          </p>
          <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900" data-id="element-324">
            Empresas líderes que construyen con FORAX
          </h2>
        </div>
      </div>

      <div className="relative overflow-hidden" data-id="element-325">
        {/* Fade edges */}
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-20 sm:w-32 bg-gradient-to-r from-white to-transparent z-10" data-id="element-326" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-20 sm:w-32 bg-gradient-to-l from-white to-transparent z-10" data-id="element-327" />

        {/* Track */}
        <motion.div ref={trackRef} className={`flex ${GAP} items-center w-max will-change-transform`} animate={shouldAnimate ? {
        x: [0, -distance]
      } : {
        x: 0
      }} transition={shouldAnimate ? {
        x: {
          duration: SCROLL_DURATION_SECONDS,
          ease: 'linear',
          repeat: Infinity
        }
      } : undefined} data-id="element-328">
          {duplicatedLogos.map((client, index) => <div key={`${client.id}-${index}`} className={`flex-shrink-0 ${ITEM_W} ${ITEM_H} flex items-center justify-center px-3`} title={client.name} data-id="element-329">
              <img src={client.url} alt={`Logo de ${client.name}`} className={`w-full ${LOGO_H} object-contain grayscale opacity-60`} loading="lazy" decoding="async" onLoad={() => setImgTick(n => n + 1)} onError={() => setImgTick(n => n + 1)} data-id="element-330" />
            </div>)}
        </motion.div>
      </div>
    </section>;
}